module.exports = __webpack_public_path__ + "static/media/live_chat.e4817790.svg";